"use strict";
var checkboxesGroupValidation = require("../components/checkboxesGroupValidation");
var scrollAnimate = require("../components/scrollAnimate");
var setClearButtonPosition = require("../components/setClearButtonPosition");

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        Array.from(this.querySelectorAll("input, select, textarea")).forEach(function (item) {
            if (!item.validity.valid) {
                // Dispatch the event
                item.dispatchEvent("invalid", this.validity);
            }
        });
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    Array.from(form.querySelectorAll(".form-control.is-invalid")).forEach(function (item) {
        item.classList.remove("is-invalid");

        if (window.mqRespond.status.lgDown) {
            if (item.nextSibling && item.nextSibling.classList && item.nextSibling.classList.contains("clear-input-button")) {
                const clearButton = item.parentNode.querySelector(".clear-input-button");

                clearButton.style.removeProperty("bottom");
            }

            if (item.parentNode && item.parentNode.classList.contains("password-form-wrapper")) {
                const eyeIconButton = item.parentNode.querySelector(".button__eye");

                if (eyeIconButton) {
                    eyeIconButton.style.removeProperty("bottom");
                }
            }
        }
    });

    Array.from(form.querySelectorAll(".invalid-feedback")).forEach(function (feedback) {
        feedback.innerText = "";
        feedback.classList.remove("visible");
    });
}

module.exports = {
    invalid: function () {
        let inputs = document.querySelectorAll("form input, form select, form textarea");

        Array.from(inputs).forEach(function (input) {
            input.addEventListener("invalid", function (e) {
                e.preventDefault();

                this.setCustomValidity("");
                if (!this.validity.valid) {
                    const parentForm = this.closest("form");

                    this.parentNode.parentNode.classList.add("validation-in-place");

                    var validationMessage = this.validationMessage;
                    this.classList.add("is-invalid");

                    if (this.validity.patternMismatch && this.dataset.patternMismatch) {
                        validationMessage = this.dataset.patternMismatch;
                    }

                    if ((this.validity.rangeOverflow || this.validity.rangeUnderflow) && this.dataset.patternError) {
                        validationMessage = this.dataset.patternError;
                    }
                    if ((this.validity.tooLong || this.validity.tooShort) && this.dataset.rangeError) {
                        validationMessage = this.dataset.rangeError;
                    }
                    if (this.validity.valueMissing && this.dataset.missingError) {
                        validationMessage = this.dataset.missingError;
                    }

                    // Attribute data-special-chars added to password field in formInput.isml which contains regex expression for non-latin chars.
                    var specialValidation = input.dataset["specialChars"];
                    // If specialValidation isn't undefined means that the attribute data-special-chars has the regex expression from formsManagement custom object (Password Additional Regex) .
                    if (typeof specialValidation != "undefined") {
                        // Check if the input contains any non-latin characters.
                        var latinChars = RegExp(specialValidation).test(input.value);
                        // If test function returns false means that what user wrote on the input contains non-latin chars so we override the current validationMessage.
                        if (!latinChars) {
                            // Override data-range-error message (current one) for data-special-chars-error (our message).
                            validationMessage = input.dataset["specialCharsError"];
                        }
                    }

                    if (this.parentNode.querySelector(".invalid-feedback") !== null) {
                        this.parentNode.querySelector(".invalid-feedback").innerText = validationMessage;
                        this.parentNode.querySelector(".invalid-feedback").classList.add("visible");
                        this.parentNode.querySelector(".invalid-feedback").setAttribute("tabindex", 0);
                    }

                    if (this.closest("form").querySelectorAll(".js-sport-preference").length) {
                        checkboxesGroupValidation();
                    }

                    if (parentForm.classList.contains("c-form__clear-fields") || this.parentNode.classList.contains("password-form-wrapper")) {
                        const eyeIconButton = this.parentNode.querySelector(".button__eye");
                        const elementBottomDistance = 12;

                        if (eyeIconButton) {
                            eyeIconButton.style.bottom = elementBottomDistance + this.parentNode.querySelector(".invalid-feedback").offsetHeight + "px";
                        }

                        if (window.mqRespond.status.lgDown) {
                            setClearButtonPosition(this);
                        }
                    }

                    let visibleErrors = document.querySelectorAll(".invalid-feedback.visible");

                    if (visibleErrors.length) {
                        const previousSibling = parentForm.previousElementSibling;

                        if (previousSibling && (previousSibling.id === "stringingShopsArea" || previousSibling.id === "stringingModalShopsArea")) {
                            if (this.parentNode.classList.contains("stringing-hidden-group")) {
                                document.querySelector(`#${previousSibling.id} .js-no-store-delivery`).classList.remove("d-none");
                                scrollAnimate($(".shipping-error"));
                            }
                        } else {
                            let firstError = visibleErrors[0];

                            scrollAnimate(firstError);
                            firstError.focus();
                        }
                    }
                }
            });
        });
    },

    submit: function () {
        let forms = document.querySelectorAll("form");

        Array.from(forms).forEach(function (form) {
            form.addEventListener("submit", function (e) {
                return validateForm.call(this, e);
            });
        });
    },

    buttonClick: function () {
        let submitButtons = document.querySelectorAll("form button[type='submit'], form input[type='submit']");

        Array.from(submitButtons).forEach(function (btn) {
            btn.addEventListener("click", function () {
                // clear all errors when trying to submit the form
                clearForm(this.closest("form"));
            });
        });
    },

    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: clearForm
    }
};
